/*
  TODO:
  1. Write nested attribute transverser the ensure attributes are present.
  To be used application wide
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProductTile from '../../shared/components/ProductTile/ProductTile';
import Analytics from '../../analytics/Analytics';


class HomepageFeaturedProducts extends Component {
  static getDomId() {
    return 'slot_homepage_featured_products';
  }

  static getComponentData() {
    return {
      products: window.seMarketplace[this.getDomId()],
    };
  }

  constructor() {
    super();
    this.analytics = new Analytics();
  }

  render() {
    const { products } = this.props;

    if (products.length === 0) {
      return null;
    }
    return (
      <div className="se-tier">
        <div className="se-container">
          <h2 className="slot-homepage-featured-products__section-title">Featured Products</h2>
          <div className="slot-homepage-featured-products__list">
            {products.map((product) => {
              const track = {
                list: 'Homepage Feature',
                analytics: this.analytics,
                measure: product,
              };

              return (
                <div key={product.id} className="slot-homepage-featured-products__card-wrapper">
                  <ProductTile product={product} track={track} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}


HomepageFeaturedProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    price: PropTypes.shape({}).isRequired,
    images: PropTypes.shape({
      productTile: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      })),
    }).isRequired,
    rebates: PropTypes.shape({
      min: PropTypes.shape({
        value: PropTypes.number.isRequired,
        formatted: PropTypes.string,
      }),
      max: PropTypes.shape({
        value: PropTypes.number.isRequired,
        formatted: PropTypes.string,
      }),
      label: PropTypes.string,
      tooltip: PropTypes.string,
    }),
    rebatePrice: PropTypes.shape({}),
    variationAttributes: PropTypes.arrayOf(PropTypes.shape({
      values: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string.isRequired,
      })),
    })),
    promotions: PropTypes.arrayOf(PropTypes.shape({})),
  })),
};

HomepageFeaturedProducts.defaultProps = {
  products: [],
};

export default HomepageFeaturedProducts;
